<template>
  <div class="price-card" :class="[highlight]">
    <p class="title">
      {{ props.title }}
    </p>
    <p v-if="prices.regularPrice" class="price-regular">
      ${{ prices.regularPrice }}
    </p>
    <p class="price-discounted">
      ${{ prices.price }}
    </p>
    <p class="billed">
      {{ props.billed }}
      <span v-if="prices.discountPercent" class="discount">Save {{ prices.discountPercent }}%</span>
    </p>
    <nuxt-link
      :to="prices.href" class="btn btn-lg"
      :class="{ 'btn-primary': highlight === 'blue', 'btn-primary btn-primary-yellow': highlight === 'yellow' }"
    >
      Get started
    </nuxt-link>
    <ul class="specifications">
      <li v-for="(spec, i) in props.specifications" :key="i" :class="{ checked: spec.checked }">
        {{ spec.name }}
      </li>
    </ul>
    <span v-if="props.promoIsActive" class="top-label">Special Offer</span>
  </div>
</template>

<script>

export default {
  props: {
    props: { type: Object, default: () => ({}), required: true },
    highlight: { type: String, default: '', required: false },
  },
  computed: {
    prices() {
      if (this.props.promoIsActive) {
        return this.props.coupon;
      }

      return this.props;
    },
  },
};
</script>

<style lang="scss" scoped>
.price-card {
  position: relative;
  background-color: var(--main-light);
  border-radius: 10px;
  padding: var(--spacing-36) var(--spacing-28);
  height: 100%;

  .title {
    margin: 0;
    font-size: 21px;
    line-height: 1.1;
    color: var(--main-dark);
    margin-bottom: var(--spacing-36);

    + .price-discounted {
      padding-top: 19px;
    }
  }

  .price-regular {
    color: var(--main-dark-light-3);
    margin: 0;
    text-decoration: line-through;
  }

  .price-discounted {
    font-size: 40px;
    line-height: 1.1;
    margin: 0;
  }

  .billed {
    margin-top: var(--spacing-8);
    color: var(--main-dark-shade-4);
    font-size: 14px;
    line-height: 28px;
  }

  .discount {
    display: inline-block;
    font-size: 14px;
    line-height: 28px;
    font-weight: 600;
    padding: 0 7px;
    border-radius: 3px;
    margin-left: var(--spacing-4);
  }

  .btn {
    display: block;
  }

  .specifications {
    padding: 0;
    margin: var(--spacing-16) 0 0;
    list-style: none;

    li {
      line-height: 24px;
      display: flex;
      align-items: start;
      padding-left: var(--spacing-24);
      margin-bottom: 10px;
      position: relative;
      background-image: url("@itbpbg/lms-components/src/assets/svg/icon-checked.svg");
      image-rendering: -webkit-optimize-contrast;
      background-position: 0 5px;
      background-repeat: no-repeat;
    }
  }

  .top-label {
    position: absolute;
    top: 0;
    margin-top: -16px;
    left: 50%;
    transform: translate(-50%, 0);
    border-radius: 5px;
    text-align: center;
    line-height: 32px;
    padding: 0 var(--spacing-24);
    color: var(--main-light);
    font-weight: 600;
  }

  &.blue {
    box-shadow: 0 4px 38px var(--accent);

    .top-label {
      background-color: var(--accent);
    }

    .discount {
      background-color: rgba(86, 191, 199, 0.2);
      color: var(--accent);
    }
  }

  &.yellow {
    box-shadow: 0 4px 31px rgba(237, 200, 67, 0.75);

    .btn-primary-yellow {
      color: var(--main-dark);
    }

    .top-label {
      color: var(--main-dark);
      background-color: var(--main-yellow);
    }

    .discount {
      background-color: rgba(237, 200, 67, 0.23);
      color: var(--main-yellow-shade-2);
    }
  }
}

@include bp($bp-laptop) {
  .price-card .title {
    height: calc(21px * 1.1 * 2);
  }
}
</style>
